import { render, staticRenderFns } from "./widget-doctype-show.vue?vue&type=template&id=2a4f020d&"
import script from "./widget-doctype-show.vue?vue&type=script&lang=js&"
export * from "./widget-doctype-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports